import { useState } from 'react'
import { AxiosError } from 'axios'
import { useAuthDataStore } from '@entities/user'
import { useCyberStore } from '@entities/tsp'
import { reqHeaders } from '@shared/config'
import { ReSendOtpRq } from '@root/api/ump-ewallet'
import { ewalletApi } from '@root/api/api'

interface UseResendCodeArgs {
  clearConfirmCodeError: () => void
}

export const useResendCode = ({ clearConfirmCodeError }: UseResendCodeArgs) => {
  const [isResendCodeLoading, setIsResendCodeLoading] = useState<boolean>(false)
  const [resendCodeError, setResendCodeError] = useState<string | null>(null)

  const { profile } = useAuthDataStore()
  const { pcekMdOrder } = useCyberStore()

  const userId = profile?.userId

  const handleSendCode = () => {
    const params: ReSendOtpRq = {
      userId,
      mdOrder: pcekMdOrder,
    }

    setIsResendCodeLoading(true)
    setResendCodeError(null)
    clearConfirmCodeError()

    ewalletApi
      .reSendOtp('b', params, {
        method: 'POST',
        headers: { ...reqHeaders },
        body: JSON.stringify(params),
      })
      .then((data) => data)
      .catch((error: AxiosError) => {
        const message = error?.message

        setResendCodeError(message)
      })
      .finally(() => setIsResendCodeLoading(false))
  }

  return {
    isResendCodeLoading,
    setIsResendCodeLoading,
    resendCodeError,
    setResendCodeError,
    handleSendCode,
  }
}
